<!-- 视频-分类 -->
<template>
	<div class="wrap2">

		<div class="header-wrap">
			<ul class="sub-tab-list">
        <li :class="{ active: commonParams.sort_type === 1 }" @click="checkSortTab(1)">默认排序</li>
        <li :class="{ active: commonParams.sort_type === 2  || commonParams.sort_type === 3}" @click="checkSortTab(commonParams.sort_type === 3 ? 2 : 3)">
          时间
          <img src="../assets/icon-6.png" class="icon" :style="{transform: `rotate(${commonParams.sort_type === 3 || commonParams.sort_type === 1 ? 0 : 180}deg)`}">
        </li>
			</ul>
		</div>

		<!-- 左侧侧边栏 -->
		<div class="leftsidebar">
			<ul class="leftsidebar-tab-list">
				<li
            v-for="(item, index) in classList"
            :key="index"
            :class="{ active: classCurrent === item.id }"
            @click="checkClass(index)"
        >
          {{ item.title }}
				</li>
			</ul>
		</div>

		<!-- 右侧侧边栏 -->
		<div class="rightsidebar">
			<ul class="list">
				<li v-for="(item, index) in classChildren" :key="index">
					<p class="list-title">{{ item.title }}</p>
					<ul class="sub-list" v-if="classResultMap[`${classCurrent},${item.id}`]">
            <!-- 无数据时显示 -->
            <div
                class="normal-box-small"
                v-if="classResultMap[`${classCurrent},${item.id}`].list.length === 0"
                style="padding: 0"
            >
              <img src="../assets/normal.png">
              暂无数据
            </div>
						<li v-for="(item2, index2) in classResultMap[`${classCurrent},${item.id}`].list" :key="index2" @click="$router.push(`/video-details?id=${item2.id}`)">
							<div class="img-box">
								<img :src="item2.cover" class="img">
								<span class="tag" v-if="item2.is_vip === 1">VIP</span>
							</div>
							<div class="item-sidebar">
								<p class="item-title">{{ item2.title }}</p>
							</div>
						</li>
						<button
                type="button"
                class="more-btn"
                v-if="classResultMap[`${classCurrent},${item.id}`].noMore === false"
                @click="getList([item.id])"
            >
              展开更多
              <img src="../assets/icon-7.png">
            </button>
					</ul>
				</li>
				<!-- 无数据时显示 -->
				<div class="normal-box-small" v-if="classChildren.length === 0">
					<img src="../assets/normal.png">
					暂无数据
				</div>
			</ul>
		</div>


	</div>
</template>

<script>
	import {VideoService} from "@/common/service";
  import {Toast} from "vant";

  export default {
    props: {
      type: {
        type: Number,
        default: 1,
      },
    },
		components: {},
    watch: {
      type(val){
        this.commonParams.type = val;
        this.getCateTree();
        // this.checkTab(val, 0);
      }
    },
		data() {
			return {
        commonParams: {
          sort_type: 1,  // 1默认2时间升序3时间降序
          type: this.type || 1,  // 类型1单个2系列
          is_tj: 0,  // 是否推荐0否1是
          page_num: 5,  // 每页数
        },

        classList: [],
        classCurrent: 0,
        classChildren: [],
        classResultMap: {},
        loading: false,
			};
		},
    mounted() {
      this.getCateTree();
    },
    methods: {
      getCateTree() {
        this.classResultMap = {};
        return VideoService.getCateTree({type: this.commonParams.type}).then(({ data }) => {
          this.classList = data.list;
          if (data.list.length > 0) {
            this.classCurrent = data.list[0].id;
            this.classChildren = data.list[0].children;
            this.getList(this.classChildren.map(item => item.id));
          }
        });
      },
      getList(ids = []) {
        this.loading = true;
        const req = (id) => {
          const key = `${this.classCurrent},${id}`;
          if (!this.classResultMap[key]) {
            this.$set(this.classResultMap, key, { page: 1, list: [], noMore: false });
          }
          const params = {
            ...this.commonParams,
            first_classify: this.classCurrent,
            second_classify: id,
            page: this.classResultMap[key].page,
          };
          return VideoService.getVideoList(params).then(({ data }) => {
            const list = data.list;
            this.classResultMap[key].list = params.page === 1 ? list : [...this.classResultMap[key].list, ...list];
            if (list.length === params.page_num) {
              this.classResultMap[key].page++;
            }
            if (list.length < params.page_num || this.classResultMap[key].list >= data.total_num) {
              this.classResultMap[key].noMore = true;
            }
            if (params.page > 1 && list.length === 0) {
              Toast('没有更多了');
            }
          });
        };
        if (ids.length > 0) {
          return Promise.all(ids.map(req)).finally(() => this.loading = false);
        } else {
          this.loading = false;
        }
      },
      checkClass(index) {
        if (this.loading) { return; }
        this.classCurrent = this.classList[index].id;
        this.classChildren = this.classList[index].children || [];
        this.classResultMap = {};
        this.getList(this.classChildren.map(item => item.id));
      },
      checkTab(type, isHot) {
        this.commonParams.type = type;
        this.commonParams.is_tj = isHot;
        this.classResultMap = {};
        this.getList(this.classChildren.map(item => item.id));
      },
      checkSortTab(sortType) {
        this.commonParams.sort_type = sortType;
        this.classResultMap = {};
        this.getList(this.classChildren.map(item => item.id));
      },

    }
	}
</script>

<style scoped>
	/* 头部样式 */
	.header-wrap {
		width: 100%;
    height: 30px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 84px;
		left: 0;
		z-index: 99999;
		background-color: #FFFFFF;
	}

	.tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 38px;
		line-height: 38px;
		font-size: 16px;
		color: #555555;
		position: relative;
	}

	.tab-list>li.active {
		font-size: 18px;
		font-weight: 500;
		color: #222222;
	}

	.tab-list>li.active::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}


	.sub-tab-list {
		width: 100%;
		height: 30px;
		display: flex;
		align-items: center;
		/*margin-top: 7px;*/
	}

	.sub-tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 30px;
		line-height: 30px;
		font-size: 12px;
		color: #555555;
		position: relative;
	}

	.sub-tab-list>li.active {
		font-weight: 500;
		color: #2A63F3;
	}

	.icon {
		width: 6px;
		margin-left: 2px;
	}

	.wrap2 {
		width: 100%;
		height: calc(var(--vh) * 100 - 84px);
		display: flex;
		flex-direction: row;
		box-sizing: border-box;
		background-color: #F4F4F4;
    padding: 30px 0 0;
    position: relative;
	}

	.leftsidebar {
		width: 80px;
		height: 100%;
		overflow-y: auto;
	}

	.leftsidebar-tab-list {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.leftsidebar-tab-list>li {
		width: 100%;
		text-align: center;
		height: 56px;
		line-height: 56px;
		font-size: 14px;
		color: #222222;
		position: relative;
	}

	.leftsidebar-tab-list>li.active {
		font-weight: 500;
	}

	.leftsidebar-tab-list>li.active::after {
		content: "";
		position: absolute;
		top: 50%;
		left: 0;
		transform: translate(0, -50%);
		background: #2A63F3;
		width: 4px;
		height: 18px;
	}

	.rightsidebar {
		width: calc(100% - 95px);
		height: 100%;
		overflow-y: auto;
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding-bottom: 10px;
	}

	.list>li {
		width: 100%;
		display: flex;
		flex-direction: column;
	}

	.list-title {
		width: 100%;
		color: #222222;
		font-size: 14px;
		font-weight: 500;
		padding: 14px 0 10px;
	}

	.sub-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		box-shadow: 0 0 16px rgba(0, 0, 0, 0.06);
		border-radius: 12px;
		padding: 14px 10px;
		box-sizing: border-box;
	}

	.sub-list>li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 18px;
	}

	.sub-list>li:last-child {
		margin-bottom: 0;
	}

	.img-box {
		width: 108px;
		height: 65px;
		position: relative;
		border-radius: 12px;
		overflow: hidden;
		margin-right: 12px;
	}

	.img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.tag {
		position: absolute;
		right: 0;
		top: 0;
		background: linear-gradient(90deg, #FFCD7C, #FFEEBA);
		border-radius: 0 4px 0 4px;
		min-width: 26px;
		height: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #222222;
		font-size: 10px;
		font-weight: 500;
	}

	.item-sidebar {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.item-title {
		width: 100%;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
		-webkit-box-orient: vertical;
		color: #222222;
		font-weight: 500;
		font-size: 14px;
	}

	.normal-box-small {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 50px 0;
	}

	.normal-box-small>img {
		width: 150px;
		margin-bottom: 9px;
	}

	.more-btn {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #2A63F3;
		font-size: 12px;
	}

	.more-btn>img {
		width: 8px;
		margin: 0 0 0 4px;
	}
</style>
